import { render, staticRenderFns } from "./event-page-open-settings-item.vue?vue&type=template&id=0c907872&scoped=true&"
import script from "./event-page-open-settings-item.vue?vue&type=script&lang=js&"
export * from "./event-page-open-settings-item.vue?vue&type=script&lang=js&"
import style0 from "./event-page-open-settings-item.vue?vue&type=style&index=0&id=0c907872&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c907872",
  null
  
)

export default component.exports